import { SHARE_URLS } from '../constants';
import {
    FacebookPayload,
    LinkBuilderParams,
    Network,
    NetworkName,
    NetworkWithOrWithoutConfig,
    TwitterPayload,
    WhatsAppPayload,
} from '../types';
import { parseNetwork } from './network';
import objectToGetParams from './objectToGetParams';
import {
    addUtmsToLinkShareUrl,
    removeSearchParamsFromUrl,
    replaceUrlInText,
} from './url';

export const buildShareLink = (
    network: NetworkWithOrWithoutConfig,
    url: string
): string | undefined => {
    const { networkName, networkConfig } = parseNetwork(network);

    const sanitizedUrl = removeSearchParamsFromUrl(url);
    const urlWithUtms = addUtmsToLinkShareUrl(sanitizedUrl, network);

    const linkBuilder = getLinkBuilder(networkName);
    return linkBuilder({ url, urlWithUtms, config: networkConfig });
};

export const getLinkBuilder = (networkName: NetworkName) => {
    return getLinkBuilders()[networkName];
};

export const getLinkBuilders = () => {
    return {
        facebook: facebookLinkBuilder,
        twitter: twitterLinkBuilder,
        whatsapp: whatsappLinkBuilder,
    };
};

export const facebookLinkBuilder = ({
    urlWithUtms,
}: LinkBuilderParams<Network.Facebook>) => {
    const payload: FacebookPayload = { u: urlWithUtms };
    return `${SHARE_URLS.facebook}${objectToGetParams(payload)}`;
};

export const twitterLinkBuilder = ({
    url,
    urlWithUtms,
    config,
}: LinkBuilderParams<Network.Twitter>) => {
    let payload: TwitterPayload = { url: urlWithUtms };

    if (config?.text) {
        const text = replaceUrlInText({
            text: config.text,
            prevUrl: url,
            nextUrl: urlWithUtms,
        });
        payload = { text };
    }

    return `${SHARE_URLS.twitter}${objectToGetParams(payload)}`;
};

export const whatsappLinkBuilder = ({
    url,
    urlWithUtms,
    config,
}: LinkBuilderParams<Network.WhatsApp>) => {
    let payload: WhatsAppPayload = { text: urlWithUtms };

    if (config?.text) {
        const text = replaceUrlInText({
            text: config.text,
            prevUrl: url,
            nextUrl: urlWithUtms,
        });
        payload = { text };
    }

    return `${SHARE_URLS.whatsapp}${objectToGetParams(payload)}`;
};
